import { useEffect, useState } from "react";
import { fetchPageBySlug } from "../api/axios";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import Banner from "../components/Index/Banner"
import HomeBlogSection from "../components/Index/HomeBlogSection"
import CoreCommitments from "../components/Index/CoreCommitments ";
import HomeContact from "../components/Index/HomeContact";
import Testimonials from "../components/sections/Testimonials";
import { fetchHomePage } from "../api/axios";
import Seo from "../components/_App/seo";
import ImageWithText from "../components/sections/ImageWithText";
import ServicesSection from "../components/sections/ServicesSection";
import HowItWorks from "../components/sections/HowItWorks";
import SolutionsSection from "../components/sections/SolutionsSection";
import Industries from "../components/sections/Industries";
import StatsSection from "../components/sections/StatsSection";
import Preloader from "../components/_App/Preloader";

const IndexPage = () => {
  const location = useLocation();
  const [pageData, setPageData] = useState(undefined);
  const [hero, setHero] = useState(null);

  const componentMap = {
    "sections.core-commitments": CoreCommitments,
    "sections.services-card": SolutionsSection,
    "sections.solution-section": ServicesSection,
    "sections.industries-section": Industries,
    "sections.strategy-section": HowItWorks,
    "sections.testimonial-section": Testimonials,
    "sections.cta-section": HomeContact,
    "sections.image-with-text": ImageWithText,
    "sections.blog-section": HomeBlogSection,
    "sections.stats-section": StatsSection,
  };

  useEffect(() => {
    let slug = location.pathname;

    if (slug === "/") {
      slug = "home";
    } else {
      slug = slug.replace("/", "");
    }

    fetchPageBySlug(slug).then((data) => {
      setPageData(data ?? null);
    });
  }, [location.pathname]);

  useEffect(() => {
    AOS.init()
    fetchHomePage().then((data) => {
      const heroSection = data?.sections?.find(
        (section) =>
          section.__component === "hero-section.hero-section"
      );

      setHero(heroSection);
    });
  }, [])
  if (pageData === undefined) return <Preloader />;
  if (!hero) return null;
  

  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={pageData?.slug}
        />
      )}
      <Banner hero={hero} />

      {pageData?.sections?.map((section) => {
        const SectionComponent = componentMap[section.__component];

        return SectionComponent ? (
          <SectionComponent key={section.id} data={section} />
        ) : null;
      })}
    </>
  );
};


export default IndexPage
